import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { collection } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore/lite";

const firebaseConfig = {
  apiKey: "AIzaSyCYKEV8ovRpo682-kn_fNL5orYWowK4jhI",
  authDomain: "restaurant-booking-dev.firebaseapp.com",
  projectId: "restaurant-booking-dev",
  storageBucket: "restaurant-booking-dev.appspot.com",
  messagingSenderId: "530194275284",
  appId: "1:530194275284:web:fbd866a50098b53a991441",
  measurementId: "G-F50MRXSJVZ",
};

const firebase = initializeApp(firebaseConfig);
getAnalytics(firebase);

const db = getFirestore(firebase);
const auth = getAuth(firebase);

const SALT = "this is a salt";

export { db, auth };
